// extracted by mini-css-extract-plugin
export default {"loading-spinner":"LoadingSpinner_loading-spinner__nm-Wl","spinner":"LoadingSpinner_spinner__Q1vlO"};